$(document).on('init:shippingprofilescontroller.nearme', function() {
  require.ensure('../controllers/shipping_profiles_controller', function(
    require
  ) {
    var ShippingProfilesController = require('../controllers/shipping_profiles_controller');
    return new ShippingProfilesController(
      'form.profiles_shipping_category_form'
    );
  });
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/shipping_profiles.initializer.js